import { FlareDataCommentSchemaPlugin } from '@common/flare-data/plugins/flare-data-comment-schema.plugin';
import { FlareDataUnknownSchemaPlugin } from '@common/flare-data/plugins/flare-data-unknown-schema.plugin';
import { VariableSetSchemaPlugin, VariableXmlNodeName } from '@common/flare-data/plugins/variable-set-schema.plugin';
import { CustomAttributesSchemaPlugin } from '@common/flare/schema/custom-attributes-schema-plugin';
import { TextSchemaPlugin } from '@common/flare/schema/text-schema.plugin';
import { SimpleDomDocument } from '@common/html/simple-dom/node';
import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { FlareDataSchema } from './flare-data-schema';

export class VariableSetSchema extends FlareDataSchema {

  get name(): string { return 'variableset'; }
  get version(): string { return '0.1.0'; }

  constructor(createGuid?: () => string) {
    const schemaPlugins: SchemaPlugin[] = [
      new VariableSetSchemaPlugin(), // all nodes should be configured as block-type nodes to be compatible with comments and unknown nodes
      new TextSchemaPlugin(), // add 'text' node due to prosemirror requirements
      new FlareDataCommentSchemaPlugin(), // add 'comment' as block-type node and 'textcomment' as inline-type node to support xml comments in the variables document
      new FlareDataUnknownSchemaPlugin(), // add unknown tags as block-type nodes that are not managed by the variables editor to allow them in the variables document
      new CustomAttributesSchemaPlugin(), // support custom attributes in the variables document
    ];

    super(schemaPlugins, createGuid);
  }

  public validateXmlDoc(xmlDoc: SimpleDomDocument): void {
    this.validateRootElement(xmlDoc, VariableXmlNodeName.Set);
  }

}
